import { render, staticRenderFns } from "./WaterTreatment.vue?vue&type=template&id=6624d3bd&scoped=true&"
import script from "./WaterTreatment.vue?vue&type=script&lang=js&"
export * from "./WaterTreatment.vue?vue&type=script&lang=js&"
import style0 from "./WaterTreatment.vue?vue&type=style&index=0&id=6624d3bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624d3bd",
  null
  
)

export default component.exports